/**
 * Function to aggregate the values of multiple selected rows when batch editing an asset.
 * @param {Array.<Object>} data - Lookup array of asset properties.
 * @param {string} key - Key of the asset property.
 * @returns {string} 'multiple' if different values was found for the same property, otherwise the value
 *
 * @example
 * data = [
 *	{prop1: value1, prop2: value2, ... },
 *	{prop1: value11, prop2: value2, ... }
 * ]
 * key = 'prop1'
 */
export const getBatchEditValue = (data, key) => {
  let response = data[0][key];

  for (let i = 1; i < data.length; i++) {
    if (data[i][key] !== response) {
      response = 'multiple';
      break;
    }
  }
  return response;
};
